export const refTypes = new Map([
  ['phones', 1],
  ['emails', 2],
  ['addresses', 3],
  ['programDischargeReasons', 4],
  ['relationship', 6],
  ['medicalSpecialties', 7],
  ['genders', 8],
  ['patientGroups', 9],
  ['languages', 10],
  ['activityTypes', 11],
  ['auditLogTimer', 12],
  ['education', 13],
  ['checkIn', 14],
  ['measurement', 15],
  ['chat', 16],
  ['broadcastCategoryList', 18],
  ['eventTypes', 20],
  ['backfillMedication', 21],
  ['enrollProgramType', 22],
  ['medicationSkipReason', 23],
  ['carePlanResponsible', 24],
  ['backfillCarePlan', 25],
  ['patientProvider', 26],
  ['patientInsurance', 27],
  ['medicalDevices', 28],
  ['prognosis', 29],
  ['telemedicine', 30],
  ['riskLevel', 31],
  ['emergencyPreparednessRiskLevel', 32],
  ['modeOfTransportation', 33],
  ['externalDocumentType', 34],
  ['patientHoldReason', 35],
  ['alertQuickCloseReasons', 36],
  ['medicalEquipmentStatuses', 38],
  ['medicalEquipmentCategories', 39],
  ['medicalDeviceTrainingStatus', 40],
  ['medicalDeviceShipmentStatus', 41],
  ['telemedicineCallType', 42],
  ['taskStatus', 43],
  ['taskType', 44],
  ['urgentCareOutcome', 45],
  ['telemedicineCallOutcome', 46],
  ['taskAction', 47],
  ['refuseServiceReasons', 48],
  ['referralReasons', 49],
  ['referralOutreachStatuses', 50],
  ['actionNotification', 51],
  ['preventiveTypes', 52],
  ['insuranceProgram', 53],
  ['applicationInstall', 54],
  ['externalReferralType', 55],
  ['patientProgressNoteType', 56],
  ['appointmentStatuses', 59],
  ['measurementMethod', 60],
  ['activityDashboardNoteStatuses', 61],
  ['bhCareManager', 62],
  ['psychConsultant', 63],
  ['cocmDischargeReason', 64],
  ['accountManager', 65],
  ['advanceDirectiveConsentType', 66],
  ['advanceDirectiveConsentCommunicationMethod', 67],
  ['advanceDirectiveConsentStatus', 68],
  ['advanceDirectiveConsentDirectives', 69],
  ['facilityCallerRoles', 70],
  ['careGapCategories', 72],
  ['tcmFacilities', 73],
  ['facilityType', 75],
  ['consentName', 76],
  ['careGiverCaseManager', 77]
])

// Reference types read by root admin pages: AdminLayout (AddCompany modal),
// scenes/Companies/scenes/Company and shared components rendered there, e.g.
// UserModal. If a root admin page starts reading a new reference selector,
// add its type here.
export const ROOT_ADMIN_REFERENCE_TYPES = [
  'addresses',
  'referralReasons',
  'genders',
  'medicalDeviceTrainingStatus',
  'patientHoldReason',
  'taskType',
  'appointmentStatuses',
  'telemedicineCallType',
  'externalDocumentType',
  'referralOutreachStatuses'
].map((refName) => refTypes.get(refName))

export const refTypesValues = new Map([
  [1, 'phones'],
  [2, 'emails'],
  [3, 'addresses'],
  [4, 'programDischargeReasons'],
  [6, 'relationship'],
  [7, 'medicalSpecialties'],
  [8, 'genders'],
  [9, 'patientGroups'],
  [10, 'languages'],
  [11, 'activityTypes'],
  [12, 'auditLogTimer'],
  [13, 'education'],
  [14, 'checkIn'],
  [15, 'measurement'],
  [16, 'chat'],
  [18, 'broadcastCategoryList'],
  [20, 'eventTypes'],
  [21, 'backfillMedication'],
  [22, 'enrollProgramType'],
  [23, 'medicationSkipReason'],
  [24, 'carePlanResponsible'],
  [25, 'backfillCarePlan'],
  [26, 'patientProvider'],
  [27, 'patientInsurance'],
  [28, 'medicalDevices'],
  [29, 'prognosis'],
  [30, 'telemedicine'],
  [31, 'riskLevel'],
  [32, 'emergencyPreparednessRiskLevel'],
  [33, 'modeOfTransportation'],
  [34, 'externalDocumentType'],
  [35, 'patientHoldReason'],
  [36, 'alertQuickCloseReasons'],
  [38, 'medicalEquipmentStatuses'],
  [39, 'medicalEquipmentCategories'],
  [40, 'medicalDeviceTrainingStatus'],
  [41, 'medicalDeviceShipmentStatus'],
  [42, 'telemedicineCallType'],
  [43, 'taskStatus'],
  [44, 'taskType'],
  [45, 'urgentCareOutcome'],
  [46, 'telemedicineCallOutcome'],
  [47, 'taskAction'],
  [48, 'refuseServiceReasons'],
  [49, 'referralReasons'],
  [50, 'referralOutreachStatuses'],
  [51, 'actionNotification'],
  [52, 'preventiveTypes'],
  [53, 'insuranceProgram'],
  [54, 'applicationInstall'],
  [55, 'externalReferralType'],
  [56, 'patientProgressNoteType'],
  [59, 'appointmentStatuses'],
  [61, 'activityDashboardNoteStatuses'],
  [62, 'bhCareManager'],
  [63, 'psychConsultant'],
  [64, 'cocmDischargeReason'],
  [65, 'accountManager'],
  [66, 'advanceDirectiveConsentType'],
  [67, 'advanceDirectiveConsentCommunicationMethod'],
  [68, 'advanceDirectiveConsentStatus'],
  [69, 'advanceDirectiveConsentDirectives'],
  [70, 'facilityCallerRoles'],
  [72, 'careGapCategories'],
  [73, 'tcmFacilities'],
  [75, 'facilityType'],
  [76, 'consentName'],
  [77, 'careGiverCaseManager']
])

export const refTypesTitles = new Map([
  ['phones', 'Phones'],
  ['emails', 'Emails'],
  ['addresses', 'Addresses'],
  ['programDischargeReasons', 'Program Discharge Reasons'],
  ['relationship', 'Relationship'],
  ['medicalSpecialties', 'Medical Specialties'],
  ['genders', 'Genders'],
  ['patientGroups', 'Patient Groups'],
  ['languages', 'Languages'],
  ['activityTypes', 'Activity Types'],
  ['auditLogTimer', 'Audit Log Timer'],
  ['broadcastCategoryList', 'Broadcast Category List'],
  ['eventTypes', 'Event Types'],
  ['medicationSkipReason', 'Medication Skip Reason'],
  ['patientProvider', 'Patient Provider'],
  ['patientInsurance', 'Patient Insurance'],
  ['medicalDevices', 'Medical Devices'],
  ['telemedicine', 'Telemedicine'],
  ['riskLevel', 'Risk Level'],
  ['emergencyPreparednessRiskLevel', 'Emergency Preparedness Risk Level'],
  ['modeOfTransportation', 'Mode of Transportation'],
  ['externalDocumentType', 'External Document Type'],
  ['patientHoldReason', 'Patient Hold Reason'],
  ['alertQuickCloseReasons', 'Alert Quick Close Reasons'],
  ['medicalEquipmentStatuses', 'DME statuses'],
  ['medicalEquipmentCategories', 'DME categories'],
  ['medicalDeviceTrainingStatus', 'Medical Device Training Status'],
  ['medicalDeviceShipmentStatus', 'Medical Device Shipment Status'],
  ['telemedicineCallType', 'Telemedicine Call Type'],
  ['taskStatus', 'Task status'],
  ['taskType', 'Task type'],
  ['taskAction', 'Task action'],
  ['urgentCareOutcome', 'Urgent Care Outcome'],
  ['telemedicineCallOutcome', 'Telemedicine Call Outcome'],
  ['refuseServiceReasons', 'Refuse Service Reasons'],
  ['referralReasons', 'Referral Reasons'],
  ['referralOutreachStatuses', 'Referral Outreach Statuses'],
  ['actionNotification', 'Action Notification Type'],
  ['preventiveTypes', 'Company Preventive Types'],
  ['insuranceProgram', 'Insurance Program'],
  ['applicationInstall', 'Application Install'],
  ['externalReferralType', 'External Referral Type'],
  ['patientProgressNoteType', 'Patient Progress Note Type'],
  ['appointmentStatuses', 'Appointment Statuses'],
  ['bhCareManager', 'BH Care Manager'],
  ['psychConsultant', 'Psych Consultant'],
  ['cocmDischargeReason', 'CoCM Discharge Reason'],
  ['accountManager', 'Account Manager'],
  ['activityDashboardNoteStatuses', 'Activity Dashboard Note Statuses'],
  ['advanceDirectiveConsentType', 'Advance Directive Consent Type'],
  [
    'advanceDirectiveConsentCommunicationMethod',
    'Advance Directive Communication Method'
  ],
  ['advanceDirectiveConsentStatus', 'Advance Directive Consent Status'],
  ['advanceDirectiveConsentDirectives', 'Advance Directive Directives'],
  ['facilityCallerRoles', 'Facility Caller Roles'],
  ['careGapCategories', 'CareGap Categories'],
  ['tcmFacilities', 'TCM Facilities'],
  ['facilityType', 'Facility Type'],
  ['consentName', 'Consent Names'],
  ['careGiverCaseManager', 'Caregiver Case Manager']
])

export const refTypesRoutes = new Map([
  ['phones', 'phones'],
  ['emails', 'emails'],
  ['addresses', 'addresses'],
  ['programDischargeReasons', 'program-discharge-reasons'],
  ['relationship', 'relationship'],
  ['medicalSpecialties', 'medical-specialties'],
  ['genders', 'genders'],
  ['patientGroups', 'patient-groups'],
  ['languages', 'languages'],
  ['activityTypes', 'activity-types'],
  ['auditLogTimer', 'audit-log-timer'],
  ['auditLogTimer', 'audit-log-timer'],
  ['broadcastCategoryList', 'broadcast-category-list'],
  ['eventTypes', 'event-types'],
  ['medicationSkipReason', 'medication-skip-reason'],
  ['patientProvider', 'patient-provider'],
  ['patientInsurance', 'patient-insurance'],
  ['medicalDevices', 'medical-devices'],
  ['telemedicine', 'telemedicine'],
  ['riskLevel', 'risk-level'],
  ['emergencyPreparednessRiskLevel', 'emergency-preparedness-risk-level'],
  ['modeOfTransportation', 'mode-of-transportation'],
  ['externalDocumentType', 'external-document-type'],
  ['patientHoldReason', 'patient-hold-reason'],
  ['alertQuickCloseReasons', 'alert-quick-close-reasons'],
  ['medicalEquipmentStatuses', 'medical-equipment-statuses'],
  ['medicalEquipmentCategories', 'medical-equipment-categories'],
  ['medicalDeviceTrainingStatus', 'medical-device-training-status'],
  ['medicalDeviceShipmentStatus', 'medical-device-shipment-status'],
  ['telemedicineCallType', 'telemedicine-call-type'],
  ['taskStatus', 'task-status'],
  ['taskType', 'task-type'],
  ['taskAction', 'task-action'],
  ['urgentCareOutcome', 'urgent-care-outcome'],
  ['telemedicineCallOutcome', 'telemedicine-call-outcome'],
  ['refuseServiceReasons', 'refuse-service-reasons'],
  ['referralReasons', 'referral-reasons'],
  ['referralOutreachStatuses', 'referral-outreach-statuses'],
  ['actionNotification', 'action-notification'],
  ['preventiveTypes', 'company-preventive-types'],
  ['insuranceProgram', 'insurance-program'],
  ['applicationInstall', 'application-install'],
  ['externalReferralType', 'external-referral-type'],
  ['patientProgressNoteType', 'patient-progress-note-type'],
  ['appointmentStatuses', 'appointment-statuses'],
  ['bhCareManager', 'bh-care-manager'],
  ['psychConsultant', 'psych-consultant'],
  ['cocmDischargeReason', 'cocm-discharge-reason'],
  ['accountManager', 'account-manager'],
  ['activityDashboardNoteStatuses', 'activity-dashboard-note-statuses'],
  ['advanceDirectiveConsentType', 'advance-directive-consent-type'],
  [
    'advanceDirectiveConsentCommunicationMethod',
    'advance-directive-consent-communication-method'
  ],
  ['advanceDirectiveConsentStatus', 'advance-directive-consent-status'],
  ['advanceDirectiveConsentDirectives', 'advance-directive-consent-directives'],
  ['facilityCallerRoles', 'facility-caller-roles'],
  ['careGapCategories', 'care-gap-categories'],
  ['tcmFacilities', 'tcm-facilities'],
  ['facilityType', 'facility-type'],
  ['consentName', 'consent-names'],
  ['careGiverCaseManager', 'caregiver-case-manager']
])

export const routesToRefs = new Map([
  ['phones', 'phones'],
  ['emails', 'emails'],
  ['addresses', 'addresses'],
  ['program-discharge-reasons', 'programDischargeReasons'],
  ['relationship', 'relationship'],
  ['medical-specialties', 'medicalSpecialties'],
  ['genders', 'genders'],
  ['patient-groups', 'patientGroups'],
  ['languages', 'languages'],
  ['activity-types', 'activityTypes'],
  ['audit-log-timer', 'auditLogTimer'],
  ['broadcast-category-list', 'broadcastCategoryList'],
  ['event-types', 'eventTypes'],
  ['medication-skip-reason', 'medicationSkipReason'],
  ['patient-provider', 'patientProvider'],
  ['patient-insurance', 'patientInsurance'],
  ['medical-devices', 'medicalDevices'],
  ['telemedicine', 'telemedicine'],
  ['risk-level', 'riskLevel'],
  ['emergency-preparedness-risk-level', 'emergencyPreparednessRiskLevel'],
  ['mode-of-transportation', 'modeOfTransportation'],
  ['external-document-type', 'externalDocumentType'],
  ['patient-hold-reason', 'patientHoldReason'],
  ['alert-quick-close-reasons', 'alertQuickCloseReasons'],
  ['medical-equipment-statuses', 'medicalEquipmentStatuses'],
  ['medical-equipment-categories', 'medicalEquipmentCategories'],
  ['medical-device-training-status', 'medicalDeviceTrainingStatus'],
  ['medical-device-shipment-status', 'medicalDeviceShipmentStatus'],
  ['telemedicine-call-type', 'telemedicineCallType'],
  ['task-status', 'taskStatus'],
  ['task-type', 'taskType'],
  ['task-action', 'taskAction'],
  ['urgent-care-outcome', 'urgentCareOutcome'],
  ['telemedicine-call-outcome', 'telemedicineCallOutcome'],
  ['refuse-service-reasons', 'refuseServiceReasons'],
  ['referral-reasons', 'referralReasons'],
  ['referral-outreach-statuses', 'referralOutreachStatuses'],
  ['action-notification', 'actionNotification'],
  ['company-preventive-types', 'preventiveTypes'],
  ['insurance-program', 'insuranceProgram'],
  ['application-install', 'applicationInstall'],
  ['external-referral-type', 'externalReferralType'],
  ['patient-progress-note-type', 'patientProgressNoteType'],
  ['appointment-statuses', 'appointmentStatuses'],
  ['bh-care-manager', 'bhCareManager'],
  ['psych-consultant', 'psychConsultant'],
  ['cocm-discharge-reason', 'cocmDischargeReason'],
  ['account-manager', 'accountManager'],
  ['activity-dashboard-note-statuses', 'activityDashboardNoteStatuses'],
  ['advance-directive-consent-type', 'advanceDirectiveConsentType'],
  [
    'advance-directive-consent-communication-method',
    'advanceDirectiveConsentCommunicationMethod'
  ],
  ['advance-directive-consent-status', 'advanceDirectiveConsentStatus'],
  ['advance-directive-consent-directives', 'advanceDirectiveConsentDirectives'],
  ['facility-caller-roles', 'facilityCallerRoles'],
  ['care-gap-categories', 'careGapCategories'],
  ['tcm-facilities', 'tcmFacilities'],
  ['facility-type', 'facilityType'],
  ['consent-names', 'consentName'],
  ['caregiver-case-manager', 'careGiverCaseManager']
])

export const HIDDEN_REF_TABLES = [
  'editReference',
  'auditLogTimer',
  'education',
  'checkIn',
  'measurement',
  'chat',
  'medicationSkipReason',
  'enrollProgramType',
  'carePlanResponsible',
  'backfillMedication',
  'backfillCarePlan',
  'patientProvider',
  'prognosis',
  'medicalDevices',
  'refuseServiceReasons',
  'referralOutreachStatuses',
  'preventiveTypes'
]
